import nodemailer from "nodemailer"
import SMTPTransport from "nodemailer/lib/smtp-transport";

export class NodemailerService {

    constructor(
        public host: string,
        public port: number,
        public user: string,
        public password: string,
        public security: boolean
      ) {}


    async sendMail(from: string, fromName: string, to: string, subject: string, message: string): Promise<{info}> {
        const transporter = nodemailer.createTransport({
            host: this.host,
            port: this.port,
            secure: this.security,
            auth: {
                user: this.user,
                pass: this.password
            },
          });

        const mailOptions: nodemailer.SendMailOptions = {
          from: {address: from, name: fromName},
          to,
          subject: subject,
          html: message,
        };
        
        const transporterInfo: SMTPTransport.SentMessageInfo = await transporter.sendMail(mailOptions)
        return {info: transporterInfo}
    }


}